<template>
  <el-dialog title="新增轮播"
             :visible.sync="visible"
             width="50%"
             :append-to-body="true"
             @open="handleOpen"
             @before-close="handleClose">
    <el-row>
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-row>
          <el-col>
            <el-form-item label="名称" prop="slideName">
              <el-input v-model="form.slideName" placeholder="请输入轮播图名称" size="medium"/>
            </el-form-item>
          </el-col>
<!--          <el-col>-->
<!--            <el-form-item label="链接地址" prop="slideHref">-->
<!--              <el-input v-model="form.slideHref" placeholder="请输入链接地址" size="medium"/>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col>
            <el-form-item label="时间" prop="time">
              <el-date-picker v-model="form.time" type="daterange" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              value-format="yyyy-MM-dd" style="width: 100%" size="medium">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="轮播图" prop="attachList"
                          style="padding: 2px 10px 22px 10px; margin-bottom:0; display: inline-block;">
              <div v-for="(attach,index) in attachList" :key="attach.id" :data-id="index" draggable="true"
                   @dragstart="handleDragStart($event)" @dragend="handleDragEnd($event)"
                   @dragover="handleDragOver($event)" @drop="handleDrop($event)"
                   style=" display: inline-block;">
                <div style="position: relative;">
                  <i @click="attachRemove(attach)" class="el-icon-close"
                     style="position: absolute; z-index: 100; top:0; right: 0;
                       background-color: #fa4f48; color: #fff;border-radius: 5px;"></i>
                  <el-image style="width: 120px;height: 120px; display: inline-block;border-radius: 15px; "
                            :src="attach.url" :id="index"/>
                </div>

              </div>
              <el-upload action="/sysAttach/uploadTempAttach/AD"
                         list-type="picture" :accept="attachAcceptType"
                         :on-error="attachHandleError" :on-success="attachHandleSuccess"
                         :on-remove="attachHandleRemove" :on-preview="attachHandlePreview"
                         :before-upload="attachBeforeUpload" :before-remove="attachBeforeRemove"
                         :on-exceed="attachHandleExceedOne" :file-list="attachList" :limit="1"
                         :show-file-list=false multiple style=" display: inline-block;padding-left: 10px;">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="color: red">上传图片大小不超过10MB，最多上传1张图片</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="float: right; right: -10px;padding-bottom: 10px;">
        <el-button type="primary" @click="submit" size="medium">确定</el-button>
        <el-button @click="handleClose" size="medium">取消</el-button>
      </div>
    </el-row>
  </el-dialog>
</template>

<script>
import {commonFormMixin} from '../../../../utils/commonFormMixin'
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";
import {addSlide} from "../../../../api/core/infoSlide";

export default {
  name: "InfoSlideForm",
  mixins: [commonFormMixin, commonAttachMixin],
  data() {
    return {
      visible: false,
      attachAcceptType: '.jpg,.jpeg,.png,.PNG,.JPG,.JPEG',
      rules: {
        slideName: [
          {required: true, message: '请输入轮播图名称', trigger: 'blur'}
        ],
        time: [
          {required: true, message: '请输入时间', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    async handleOpen() {
      this.form = {...this.selRow};
      if (this.form.id) {
        this.attachList = await this.findAttachListByDataId(this.form.id, 'AD')
      }
    },
    async submit() {
      let valid = await this.$refs.form.validate().catch(() => {
      });
      if (!valid) return;
      this.form.beginTime = this.form.time[0];
      this.form.endTime = this.form.time[1];
      addSlide(this.form).then(res =>{
        this.handleClose();
        this.$emit('refreshList')
      })
    },
    handleDragStart(event) {
      this.startExchangeIndex = event.target.getAttribute('id') || event.target.parentNode.getAttribute('id')
    },
    handleDragOver(event) {
      event.preventDefault()
    },
    handleDragEnd() {
      let startTeamIndex = parseInt(this.startExchangeIndex.split('-')[0])
      let endTeamIndex = parseInt(this.endExchangeIndex.split('-')[0])
      let dataList = [...this.attachList]
      if (this.startExchangeIndex < this.endExchangeIndex)
        this.attachList.forEach((data, index) => {//30
          if (index < startTeamIndex)
            dataList[index] = data
          else if (index === startTeamIndex)
            dataList[endTeamIndex] = data
          else if (index > startTeamIndex && index <= endTeamIndex)
            dataList[index - 1] = data
          else
            dataList[index] = data
        })
      else
        this.attachList.forEach((data, index) => {//3   1
          if (index < endTeamIndex)
            dataList[index] = data
          else if (index === endTeamIndex)
            dataList[index] = this.attachList[startTeamIndex]
          else if (index > endTeamIndex && index <= startTeamIndex)
            dataList[index] = this.attachList[index - 1]
          else
            dataList[index] = data
        })
      this.attachList = dataList
    },
    handleDrop(event) {
      this.endExchangeIndex = event.target.getAttribute('id') || event.target.parentNode.getAttribute('id')
    },
    attachHandleExceedOne(files, fileList) {
      this.$message.warning(`只能上传1张图片`)
    },
    attachBeforeRemove(file) {
      if (file.status !== 'success') return;
      return this.$confirm(`确定删除图片 ${file.name}重新上传？`, '提示', {type: 'warning'}).then(_ => {
        if (file.id && file.state && file.state === 1) {
          this.postRequest('/sysAttach/delete', {'attachId': file.id});
        }
      });
    },
    async attachRemove(file) {
      if (file.status !== 'success') return;
      this.$confirm(`确定移除 ${file.name}？`, '提示', {type: 'warning'}).then(_ => {
        this.attachList.map((data, index) => {
          if (file.id === data.id) {
            this.attachList.splice(index, 1);
            this.postRequest('/sysAttach/delete', {'attachId': file.id});
          }
        })
      })
    },
    handleClose() {
      this.form = {}
      this.visible = false
      this.attachList = []
    }
  }
}
</script>

<style scoped>

</style>